module.exports = __webpack_public_path__ + "img/logo.aa43b090.png";